import useApi, { ApiOptions } from '../base/useApi';
import CategoryHeaderDTO from '@src/adapters/dto/category/CategoryHeaderDTO';

interface Params {}

interface Result {
  items: CategoryHeaderDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/category/for_selection/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindCategoryForSelectionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindCategoryForSelectionLazy;
